(function (w, d) {
  'use strict';
  if (w.DiyonaPrivacy) return;
  var VERSION = 1, COOKIE = 'diyona_privacy_v1', LEGACY = 'diyona_cookie_consent';
  var cp = null, ready = false, localChoice = null, saving = false, listeners = [], once = [];
  var last = null, loading = false, attempts = 0, migrated = false;
  var saved = readChoice(), legacyDecline = read(LEGACY) === 'declined';
  function read(name) {
    try { var m = d.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; } catch (_) { return ''; }
  }
  function readChoice() { try { var v = JSON.parse(read(COOKIE)); return v && v.v === VERSION && typeof v.analytics === 'boolean' && typeof v.marketing === 'boolean' && typeof v.preferences === 'boolean' && typeof v.sale_of_data === 'boolean' ? v : null; } catch (_) { return null; } }
  function write(name, value) { d.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure'; }
  function gpc() { return w.navigator.globalPrivacyControl === true; }
  function call(method, fallback) { try { return cp && typeof cp[method] === 'function' ? cp[method]() : fallback; } catch (_) { return fallback; } }
  function snapshot() {
    var region = String(call('getRegion', '') || '').toUpperCase();
    var us = /^US(?:[A-Z0-9]{0,3})$/.test(region);
    var visitor = call('currentVisitorConsent', {}) || {};
    var choice = localChoice || saved;
    var blocked = gpc() || (!choice && legacyDecline);
    var s = { version: VERSION, ready: ready, region: region, mode: us ? 'opt-out' : 'opt-in', gpc: gpc(), hasChoice: !!choice || legacyDecline || ['analytics', 'marketing', 'preferences', 'sale_of_data'].some(function (k) { return visitor[k] === 'yes' || visitor[k] === 'no'; }) };
    var methods = { analytics: 'analyticsProcessingAllowed', marketing: 'marketingAllowed', preferences: 'preferencesProcessingAllowed', sale_of_data: 'saleOfDataAllowed' };
    Object.keys(methods).forEach(function (key) {
      var explicit = choice ? choice[key] === true : visitor[key] === 'yes';
      var refused = (choice && choice[key] === false) || visitor[key] === 'no';
      s[key] = ready && !blocked && !refused && (us || explicit) && call(methods[key], false) === true;
      // A pending refusal applies immediately, before Shopify's async callback.
      if (localChoice && localChoice[key] === false) s[key] = false;
    });
    s.advertisingAllowed = s.marketing && s.sale_of_data;
    return s;
  }
  function permitted(kind, s) { return kind === 'advertising' ? s.advertisingAllowed : s[kind] === true; }
  function notify() {
    var next = snapshot(), changed = JSON.stringify(next) !== JSON.stringify(last), previous = last;
    last = next;
    if (changed) {
      if (previous && previous.advertisingAllowed && !next.advertisingAllowed) clearAdvertising();
      if (previous && previous.analytics && !next.analytics) clearAnalytics();
      listeners.slice().forEach(function (fn) { try { fn(next, previous); } catch (_) {} });
      try { d.dispatchEvent(new CustomEvent('diyona:privacy-change', { detail: next })); } catch (_) {}
      // Compatibility with the existing session SDK. Its patched decline handler drops queued events.
      try { d.dispatchEvent(new CustomEvent('diyona:cookie-consent', { detail: { status: next.analytics ? 'accepted' : 'declined' } })); } catch (_) {}
    }
    once.forEach(function (job) { if (!job.ran && permitted(job.kind, next)) { job.ran = true; try { job.fn(); } catch (_) {} } });
  }
  function clearCookie(name) {
    ['', '; Domain=' + location.hostname, '; Domain=.diyona.com'].forEach(function (domain) { d.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax; Secure' + domain; });
  }
  function clearAdvertising() {
    ['_diy_ft', '_diy_lt', '_diy_vid', '_fbp', '_fbc', '_rdt_uuid'].forEach(clearCookie);
    try { ['diy_fp_flags', 'diy_ad'].forEach(function (k) { w.localStorage.removeItem(k); }); } catch (_) {}
    try { var u = new URL(location.href); if (u.searchParams.has('dyad')) { u.searchParams.delete('dyad'); w.history.replaceState(w.history.state, '', u.pathname + u.search + u.hash); } } catch (_) {}
    clearCartAttribution();
  }
  function clearAnalytics() {
    ['_clck', '_clsk'].forEach(clearCookie);
    w.DIY_TRACK_Q = [];
  }
  function clearCartAttribution() {
    if (!read('cart') || !w.fetch) return;
    var attrs = {};
    ['_utm_source', '_utm_medium', '_utm_campaign', '_utm_content', '_landing_url', '_referrer', '_first_touch_ts', '_visitor_id', '_last_source', '_last_medium', '_last_content', '_ad_id', '_last_ad_id', '_fbp', '_fbc'].forEach(function (k) { attrs[k] = ''; });
    w.fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }), keepalive: true }).catch(function () {});
  }
  function synchronizeRefusal() {
    if (!ready || saving || migrated) return;
    var allOff = gpc() || (!saved && legacyDecline);
    var visitor = call('currentVisitorConsent', {}) || {};
    var values = {}, needsSync = false;
    ['analytics', 'marketing', 'preferences', 'sale_of_data'].forEach(function (k) {
      if (allOff || (saved && saved[k] === false)) { values[k] = false; if (visitor[k] !== 'no') needsSync = true; }
    });
    if (needsSync) {
      migrated = true;
      // Honor a browser opt-out or an existing user refusal; never manufacture a positive consent.
      try { cp.setTrackingConsent(values, function (result) { if (result && result.error) migrated = false; notify(); }); } catch (_) { migrated = false; }
    }
  }
  function load() {
    if (loading || ready) return;
    if (!(w.Shopify && typeof w.Shopify.loadFeatures === 'function')) { if (++attempts < 40) w.setTimeout(load, 250); return; }
    loading = true;
    try { w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      loading = false;
      if (error || !w.Shopify.customerPrivacy) { if (++attempts < 40) w.setTimeout(load, 500); return; }
      cp = w.Shopify.customerPrivacy; ready = true;
      synchronizeRefusal(); notify();
      if (!last.advertisingAllowed && (legacyDecline || gpc() || (saved && !saved.marketing))) clearAdvertising();
    }); } catch (_) { loading = false; if (++attempts < 40) w.setTimeout(load, 500); }
  }
  function setChoice(values, callback) {
    if (saving) return;
    if (!ready) { load(); if (callback) callback(new Error('Privacy settings are still loading. Please try again.')); return; }
    var next = { v: VERSION, ts: Date.now() };
    ['analytics', 'marketing', 'preferences', 'sale_of_data'].forEach(function (k) { next[k] = !gpc() && values[k] === true; });
    saving = true; localChoice = next;
    // Persist refusals before any asynchronous work, so navigation cannot discard them.
    saved = next; write(COOKIE, JSON.stringify(next));
    write(LEGACY, next.analytics || next.marketing || next.preferences || next.sale_of_data ? 'custom' : 'declined');
    legacyDecline = false; notify();
    var done = false;
    var timer = w.setTimeout(function () { finish(new Error('Your choice is saved on this device. Please retry to sync it with checkout.')); }, 8000);
    function finish(error) { if (done) return; done = true; w.clearTimeout(timer); saving = false; if (!error) localChoice = null; notify(); if (callback) callback(error); }
    try { cp.setTrackingConsent({ analytics: next.analytics, marketing: next.marketing, preferences: next.preferences, sale_of_data: next.sale_of_data }, function (result) { finish(result && result.error ? new Error('Could not sync your privacy choice. Please try again.') : null); }); } catch (error) { finish(error); }
  }
  w.DiyonaPrivacy = {
    version: VERSION, get: snapshot,
    allowed: function (kind) { return permitted(kind, snapshot()); },
    subscribe: function (fn) { listeners.push(fn); fn(snapshot(), null); return function () { listeners = listeners.filter(function (f) { return f !== fn; }); }; },
    whenAllowed: function (kind, fn) { once.push({ kind: kind, fn: fn, ran: false }); notify(); },
    set: setChoice,
    retry: function () { attempts = 0; load(); }
  };
  // Enforce the same decision at the two first-party network sinks, including
  // delayed SDK batches and unload beacons queued before a visitor opts out.
  function networkAllowed(url) {
    try {
      var u = new URL(typeof url === 'string' ? url : url.url, location.href);
      if (u.origin === 'https://diyona-ad-dashboard.vercel.app' && u.pathname === '/api/collect') return permitted('advertising', snapshot());
      if (u.origin === 'https://ofjwrrqzzbcnmkkmlawl.supabase.co' && u.pathname === '/functions/v1/diy-collect') return permitted('analytics', snapshot());
    } catch (_) {}
    return true;
  }
  if (w.fetch) {
    var originalFetch = w.fetch;
    w.fetch = function (url, init) { if (!networkAllowed(url)) return Promise.resolve(new Response(null, { status: 204 })); return originalFetch.call(this, url, init); };
  }
  if (w.navigator.sendBeacon) {
    var originalBeacon = w.navigator.sendBeacon;
    w.navigator.sendBeacon = function (url, body) { return networkAllowed(url) ? originalBeacon.call(this, url, body) : false; };
  }
  d.addEventListener('visitorConsentCollected', function () {
    // Native checkout/preferences changes are authoritative once our own save finishes.
    if (!saving && ready) {
      var current = call('currentVisitorConsent', {}) || {};
      if (saved && ['analytics', 'marketing', 'preferences', 'sale_of_data'].every(function (k) { return current[k] === 'yes' || current[k] === 'no'; })) {
        ['analytics', 'marketing', 'preferences', 'sale_of_data'].forEach(function (k) { saved[k] = current[k] === 'yes'; });
        write(COOKIE, JSON.stringify(saved));
      }
    }
    notify();
  });
  w.addEventListener('pageshow', function () { saved = readChoice(); legacyDecline = read(LEGACY) === 'declined'; notify(); synchronizeRefusal(); });
  w.addEventListener('focus', function () { saved = readChoice(); legacyDecline = read(LEGACY) === 'declined'; notify(); synchronizeRefusal(); });
  load();
})(window, document);
